import React, { useEffect, useState } from "react";
import "./Auth.scss";
import { logo } from "assets/images";
import { callIcon } from "assets/icons";
import { Input, LoadingButton } from "components/form";
import { sendOtpApi } from "services/auth";
import { allowMobileNumber } from "utils/inputValueValidation";
import { failMessage, successMessage } from "utils/toastMessage";

const Login = ({ setLoginStep, setInput, input }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ mobile: '' })
  const [responseMsg, setResponseMsg] = useState('')
  // console.log('REACT_APP_VARIABLE', process.env.REACT_APP_VARIABLE)

  //--------------validation--------------
  const validation = () => {
    let errorMessage = {}
    let status = true;
    if (!input?.mobile) {
      errorMessage['mobile'] = 'Please enter mobile number'
      status = false;
    }
    setError(errorMessage)
    return status
  }
  //----------onChange-handler--------------cb max, pma dolle
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: allowMobileNumber(value) })
  }

  //---------send-otp-handler-----------------
  const handleSendOtp = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (validation()) {
      try {
        setLoading(true);
        const res = await sendOtpApi(input);
        // console.log('res', res)
        if (res?.status === 200) {
          successMessage(res)
          setLoginStep('otp')
        } else {
          setResponseMsg(res?.message || '')
        }
      } catch (e) {
        console.log("Error:-", e.message);
      } finally {
        setLoading(false);
      }
    }
  };



  useEffect(() => {
    if (responseMsg) {
      const timer = setTimeout(() => {
        setResponseMsg('');
      }, 4000);
      return () => clearTimeout(timer); // Cleanup function
    }
  }, [responseMsg]);

  
  return (
    <form onSubmit={handleSendOtp}>
      <img src={logo} className="logo_image" alt="logo" />
      <h2>Login with your mobile number</h2>
      <p>
        Provide your registered mobile number to login to your Volt account.
        <br />
        {responseMsg && <span className="text-danger">{responseMsg}</span>}
      </p>
      <div className="form_field">
        <div className="input_wrap">
          <img src={callIcon} alt="icon" />
          <Input
            type="tel"
            maxLength={13}
            name="mobile"
            value={input?.mobile || ""}
            onChange={onChangeHandler}
            className="form-control input"
            placeholder="Input your mobile number"
            error={error?.mobile}
          />
        </div>
      </div>

      <div className="button_wrap">
        <LoadingButton loading={loading} type="button" onClick={handleSendOtp}>
          Login
        </LoadingButton>
      </div>
    </form>
  );
};

export default Login;
